import TestPackageGroupModel from "@/models/lab/TestPackageGroupModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

export default class TestPackageGroupCollection extends LabServiceCollection {
  model() {
    return TestPackageGroupModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.sortAddAsc('position');

    return CollectionFilter;
  }

}
